import { useLocalStorage } from '@/hooks/use-local-storage'

import { PlaceFeatureGroup } from '../../features/places-features.constants'
import { PLACE_FEATURES_OPEN_GROUPS_KEY } from '../place-details.constants'

// Note: a stable reference, so `useLocalStorage` does not re-subscribe on every render
const NO_OPEN_GROUPS: string[] = []

// Note: the opened groups of every tab share one stored list; a tab only reads and writes its own groups
export const usePlaceOpenGroups = (groups: readonly PlaceFeatureGroup[]) => {
  const [stored, setStored] = useLocalStorage<string[]>(
    PLACE_FEATURES_OPEN_GROUPS_KEY,
    NO_OPEN_GROUPS,
  )
  const storedGroups = Array.isArray(stored) ? stored : NO_OPEN_GROUPS
  const openGroups = groups.filter((group) => storedGroups.includes(group))
  const areAllOpen = openGroups.length === groups.length

  const save = (next: readonly PlaceFeatureGroup[]) =>
    setStored([
      ...storedGroups.filter((group) => !(groups as readonly string[]).includes(group)),
      ...next,
    ])

  const toggleGroup = (group: PlaceFeatureGroup) =>
    save(
      openGroups.includes(group)
        ? openGroups.filter((openGroup) => openGroup !== group)
        : [...openGroups, group],
    )

  const toggleAll = () => save(areAllOpen ? [] : groups)

  return { areAllOpen, openGroups, toggleAll, toggleGroup }
}
